var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_5_1.png"
    }
  }), _vm._v(" "), _c('myTab', {
    attrs: {
      "tab-list": _vm.tabList,
      "smallSize": "",
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 3) ? [_c('div', {
    staticClass: "container mt-50"
  }, _vm._l((_vm.menuList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "mb-20 flex-container-row"
    }, [_c('a', {
      staticClass: "bold item-title mr-20 color-fff fs-20 flex-container nav_title",
      on: {
        "click": function($event) {
          return _vm.toNav(v)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(v.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(v.en))])]), _vm._v(" "), (v.subMenu.length) ? [_c('div', {
      staticClass: "flex-container-row_wrap"
    }, _vm._l((v.subMenu), function(sv, si) {
      return _c('a', {
        key: si,
        staticClass: "item-subTitle mr-20  color-fff fs-20 flex-container",
        on: {
          "click": function($event) {
            return _vm.toSubUrl(v, sv, si)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(sv.subTitle))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(sv.en))])])
    }), 0)] : _vm._e()], 2)
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 2) ? [_c('div', {
    staticClass: "container text-center color-ccc fs-20"
  }, [_c('b-container', [_c('b-row', _vm._l((_vm.linkList), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "xs": "6",
        "sm": "6",
        "md": "4",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "item mt-40 text-center img_wrap"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (v.img),
        expression: "v.img"
      }]
    }), _vm._v(" "), _c('a', {
      staticClass: "fs-16 mt-20",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(v.title))])])])
  }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 0) ? [_vm._m(1)] : _vm._e(), _vm._v(" "), _c('page-footer')], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "color-fff fs-20 mt-50 mb-50",
    attrs: {
      "stlye": "text-indent:2em;"
    }
  }, [_vm._v("\n           \n          本网站包含之所有内容：文本、图形、LOGO、创意、及软件等之所有权归属广州国际汽车展览会组委会，受中国及国际版权法的保护。对本网站上所有内容之复制（意指收集、组合和重新组合），本网站享有排他权并受中国及国际版权法的保护。本网站的特有信息经网站许可方能转载，并需标明出处。\n      ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container flex-container-row justify-spacebeteen"
  }, [_c('div', {
    staticClass: "mb-50 color-fff mt-50 fs-20 lh-custom flex-1"
  }, [_c('div', [_vm._v("广州展联展览服务有限公司")]), _vm._v(" "), _c('div', [_vm._v("\n          地址：广州市海珠区凤浦中路 669 号广交会大厦 B 座908室\n        ")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "tel:020-89268911"
    }
  }, [_vm._v("电话：020-89138182")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "tel:020-89268965"
    }
  }, [_vm._v("传真：020-89138054")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.expounion.com.cn/"
    }
  }, [_vm._v("网址：www.expounion.com.cn")])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-50 color-fff mt-50 fs-20 lh-custom flex-container-col flex-1"
  }, [_c('div', [_vm._v("Guangzhou Zhanlian Exhibition Service Co., Ltd")]), _vm._v(" "), _c('div', [_vm._v("\n            Address：Room 908, Canton Fair Building B, No. 669 FengpuMiddle Road, HaizhuDistrict, Guangzhou City\n        ")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "tel:020-89268911"
    }
  }, [_vm._v("Tel：020-89138182")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "tel:020-89268965"
    }
  }, [_vm._v("Fax：020-89138054")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.expounion.com.cn/"
    }
  }, [_vm._v("Website：www.expounion.com.cn")])])])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a24a526","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/friendlyLink/index.vue
// module id = null
// module chunks = 